/*
 * @Author: Suroc
 * @Date: 2023-11-26 17:46:11
 * @LastEditTime: 2024-03-05 12:14:37
 * @Description: 
 */
import axios from "axios"; //引入
import QS from "qs"; // 引入qs模块，用来序列化post类型的数据，后面会提到

const _axios = axios.create({
  baseURL: AxiosApi,
  timeout: 15000 * 120, // 请求超时时间
});


if (window.location.hostname == "36.103.232.201") {
  AxiosApi = "http://36.103.232.201:8800";
  EToken = "c2625f331d7daea93a7d9f72c8169c00ce539e08825032767b986698c3770ef4";
} else {
  AxiosApi = "http://36.103.232.201:8800";
  EToken = "2f73d81fce20d869c2534b5dd3a1311bc4af86ef0ab6b41d1ef948d0174152dc";
}

/* 请求拦截器（请求之前的操作） */
_axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => Promise.reject(err)
);

/* 请求之后的操作 */
_axios.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    return Promise.reject(err);
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(AxiosApi + url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(AxiosApi + url, QS.stringify(params))
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * post方法，对应postFormData提交方式
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postForm (url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(AxiosApi + url, params, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
